// extracted by mini-css-extract-plugin
export default {"respondentPanel":"respondentPanel___HMJGbSP","bold":"bold___HMJGbSP","contentTitle":"contentTitle___HMJGbSP"};